import React, { Component } from "react";
import Popover from "material-ui/Popover";
import Menu from "material-ui/Menu";
import MenuItem from "material-ui/MenuItem";
import { observer } from "mobx-react";

import { CNPJ } from "cpf_cnpj";

import { StyledButton, EntitySelector, If } from "components/support";

import Icon from "material-ui-next/Icon";

class UserInfo extends Component {
  state = {
    open: false
  };

  handleEditInfo = () => {
    this.props.onEditInfo();
    this.handleRequestClose();
  };

  handleTouchTap = event => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget
    });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  handleCompanyChange = () => {
    this.handleRequestClose();
    this.props.onCompanyChange();
  };

  render() {
    const {
      onLogout,
      onHelp,
      multilocalityOpen,
      onClose,
      onSelectCompany,
      companySearchOptions
    } = this.props;

    return (
      <div className="topbar__user-info">
        <div className="topbar__user-info__login">
          <StyledButton
            flat
            className="topbar__user-info__login__label"
            onTouchTap={this.handleTouchTap}
            leftIcon={<Icon style={{ padding: 0 }}>account_circle</Icon>}
            label={this.props.name}
            rightIcon={<Icon style={{ padding: 0 }}>arrow_drop_down</Icon>}
          />
          <If test={process.env.REACT_APP_WHITELABEL_NAME === "PDVEND"}>
            <StyledButton
              flat
              onTouchTap={onHelp}
              leftIcon={<Icon style={{ padding: 0 }}>help</Icon>}
            />
          </If>
        </div>
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          targetOrigin={{ horizontal: "right", vertical: "top" }}
          onRequestClose={this.handleRequestClose}
        >
          <Menu>
            <If test={this.props.displayCompanyChangeModal}>
              <MenuItem
                primaryText="Trocar Empresa"
                onTouchTap={this.handleCompanyChange}
              />
            </If>
            <MenuItem
              primaryText="Alterar Dados Pessoais"
              onTouchTap={this.handleEditInfo}
            />
            <MenuItem primaryText="Sair" onTouchTap={onLogout} />
          </Menu>
        </Popover>

        <EntitySelector
          title="Selecione a empresa desejada"
          open={multilocalityOpen}
          searchOptions={companySearchOptions}
          onSelect={company => onSelectCompany(company)}
          parser={company => ({
            key: company.uuid,
            title: company.slug,
            subtext: company.fiscal_informations
              ? CNPJ.format(company.fiscal_informations.cnpj)
              : ""
          })}
          onClose={() => onClose()}
        />
      </div>
    );
  }
}

export default observer(UserInfo);



// WEBPACK FOOTER //
// ./src/components/support/topbar/user-info/index.jsx